import defaultTheme, { audioTheme } from './audioThemes'
class AudioLib {
  private static instance: AudioLib
  private static audio_select?: string // click that opens new ui
  private static audio_open?: string // click that opens new ui
  private static audio_close?: string // click that closes existing ui
  private static audio_cancel?: string // click that cancels current operations
  private static audio_toggle?: string // click that changes a boolean value
  private static audio_change?: string // click that confirms the change
  private static audio_quickChange?: string // click that confirms a small change
  private static audio_create?: string // confirmation that creates new data
  private static audio_update?: string // confirmation on existing data
  private static audio_delete?: string // confirmation on deleting data
  private static audio_login?: string // feedback on login
  private static audio_logout?: string // feedback on logout
  private static audio_critical?: string // feedback on crash
  private static audio_error?: string //feedback on error

  private constructor(theme: audioTheme = defaultTheme) {
    AudioLib.audio_select = theme.select
    AudioLib.audio_open = theme.open
    AudioLib.audio_close = theme.close
    AudioLib.audio_cancel = theme.cancel
    AudioLib.audio_toggle = theme.toggle
    AudioLib.audio_change = theme.change
    AudioLib.audio_quickChange = theme.quickChange
    AudioLib.audio_create = theme.create
    AudioLib.audio_update = theme.update
    AudioLib.audio_delete = theme.delete
    AudioLib.audio_login = theme.login
    AudioLib.audio_logout = theme.logout
    AudioLib.audio_critical = theme.critical
    AudioLib.audio_error = theme.error
  }

  public static getInstance(): AudioLib {
    if (!AudioLib.instance) {
      AudioLib.instance = new AudioLib()
    }

    return AudioLib.instance
  }
  public static instantiate(): void {
    if (!AudioLib.instance) {
      AudioLib.instance = new AudioLib()
    }
  }
  // divider
  public static select(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_select).play()
  }
  public static open(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_open).play()
  }
  public static close(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_close).play()
  }
  public static cancel(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_cancel).play()
  }
  public static toggle(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_toggle).play()
  }
  public static change(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_change).play()
  }
  public static quickChange(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_quickChange).play()
  }
  public static create(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_create).play()
  }
  public static update(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_update).play()
  }
  public static delete(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_delete).play()
  }
  public static logout(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_logout).play()
  }
  public static login(): void {
    AudioLib.instantiate()
    console.log(AudioLib.audio_login)

    new Audio(AudioLib.audio_login).play()
  }
  public static critical(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_critical).play()
  }
  public static error(): void {
    AudioLib.instantiate()

    new Audio(AudioLib.audio_error).play()
  }
}
export default AudioLib
